import Api from "./api";

class CatalogLoaderService {
    api = new Api();

    getAllSubGroups() {
        return this.api.get('/admin/catalog-loader/get-all-categories');
    }

    getSubGroupAttributes(subGroupId) {
        return this.api.get('/admin/catalog-loader/sub-group-attributes', {
            subGroupId: subGroupId
        });
    }

    checkIsAttribute(attributeName) {
        return this.api.post('/admin/catalog-loader/check-is-attribute', {
            attributeName: attributeName
        });
    }

    checkStructureDuplicate(data) {
        return this.api.post('/admin/catalog-loader/check-structure-duplicate', data);
    }

    checkHierarchy(rowsData) {
        return this.api.post('/admin/catalog-loader/check-hierarchy', rowsData);
    }

    loadData(rows) {
        return this.api.post('/admin/catalog-loader/load-data-from-table', {
            rows: rows
        });
    }

    checkAttributes(mainAttributes, anotherAttributes, attributeValues) {
        return this.api.post('/admin/catalog-loader/check-attributes', {
            mainAttributes: mainAttributes,
            anotherAttributes: anotherAttributes,
            attributeValues: attributeValues
        })
    }
}

export default new CatalogLoaderService();